import React, { Component, Fragment } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Row, Col, Button } from 'reactstrap';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import AlertModal from '../../../shared/components/Modal';

class LabsPatientTemplates extends Component {

    constructor() {
        super();
        this.state = {
            otherTemplates: [],
            selectedTemplate: null,
            templateData: null,
            enabledTemplate: false,
            containData: null,
            colorAlertModal: "",
            messageAlertModal: "",
            showAlertModal: false
        }
    }

    componentDidMount() {
        this.loadDataTemplates();
    }

    handlerSelectedTemplate = (value) => {
        this.setState({ selectedTemplate: value }, () => {
            let dataTemplate = this.state.otherTemplates.find(dat => dat.id_laboratorio_plantillas == this.state.selectedTemplate);
            if (dataTemplate != null && dataTemplate != undefined) {
                this.setState({
                    templateData: dataTemplate.plantilla,
                    enabledTemplate: dataTemplate.habilitado,
                    containData: dataTemplate.contenido
                });
            }
            else {
                this.setState({
                    templateData: "",
                    enabledTemplate: false,
                    containData: ""
                });
            }
        });
    }

    handlerTemplateData = (value) => {
        this.setState({ templateData: value });
    }

    handlerEnabledTemplate = (value) => {
        this.setState({ enabledTemplate: value });
    }

    handlerContainData = (value) => {
        this.setState({ containData: value });
    }

    saveDataTemplate = async () => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}pantillas-laboratorio/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                plantilla: this.state.templateData,
                habilitado: this.state.enabledTemplate,
                contenido: this.state.containData
            })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Error');
            }
        }).then((data) => {
            if (data.plantilla != null) {
                this.setState({
                    messageAlertModal: "Plantilla de Laboratorio se guardo exitosamente",
                    colorAlertModal: "success",
                    showAlertModal: true,
                    otherTemplates: [...this.state.otherTemplates, data.plantilla],
                    templateData: "",
                    enabledTemplate: false,
                    containData: ""
                });
            }
            else {
                this.setState({
                    messageAlertModal: "Ha ocurrido un error en el Sistema",
                    colorAlertModal: "danger",
                    showAlertModal: true
                });
            }
        }).catch(err => {
            this.setState({
                messageAlertModal: "Ha ocurrido un error en el Sistema",
                colorAlertModal: "danger",
                showAlertModal: true
            });
        });
    }

    updateDataTemplate = async () => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}pantillas-laboratorio/update`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                id_laboratorio_plantillas: this.state.selectedTemplate,
                plantilla: this.state.templateData,
                habilitado: this.state.enabledTemplate,
                contenido: this.state.containData
            })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Error');
            }
        }).then((data) => {
            if (data.plantilla != null) {
                let dataArr = this.state.otherTemplates.filter(() => true);
                let indexData = dataArr.findIndex(dat => parseInt(dat.id_laboratorio_plantillas) == parseInt(this.state.selectedTemplate));
                dataArr[indexData].plantilla = data.plantilla.plantilla;
                dataArr[indexData].habilitado = data.plantilla.habilitado;
                dataArr[indexData].contenido = data.plantilla.contenido;
                this.setState({
                    messageAlertModal: "Plantilla de Laboratorio se actualizo exitosamente",
                    colorAlertModal: "success",
                    showAlertModal: true,
                    otherTemplates: dataArr
                });
            }
            else {
                this.setState({
                    messageAlertModal: "Ha ocurrido un error en el Sistema",
                    colorAlertModal: "danger",
                    showAlertModal: true
                });
            }
        }).catch(err => {
            console.log(err);
            this.setState({
                messageAlertModal: "Ha ocurrido un error en el Sistema",
                colorAlertModal: "danger",
                showAlertModal: true
            });
        });
    }

    deleteDataTemplate = async () => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}pantillas-laboratorio/delete`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                id_laboratorio_plantillas: this.state.selectedTemplate
            })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                let dataArr = this.state.otherTemplates.filter((dat) => dat.id_laboratorio_plantillas != this.state.selectedTemplate);
                this.setState({
                    messageAlertModal: "Plantilla de Laboratorio se elimino exitosamente",
                    colorAlertModal: "success",
                    showAlertModal: true,
                    otherTemplates: dataArr,
                    selectedTemplate: null,
                    templateData: "",
                    enabledTemplate: false,
                    containData: ""
                });
            }
            else {
                throw new Error('Error');
            }
        }).catch(err => {
            console.log(err);
            this.setState({
                messageAlertModal: "Ha ocurrido un error en el Sistema",
                colorAlertModal: "danger",
                showAlertModal: true
            });
        });
    }

    validateSendTemplate = () => {
        if (this.state.selectedTemplate != null && this.state.selectedTemplate != undefined) {
            this.updateDataTemplate();
        }
        else {
            this.saveDataTemplate();
        }
    }

    loadDataTemplates = async () => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}pantillas-laboratorio/listar`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Error');
            }
        }).then((data) => {
            this.setState({
                otherTemplates: data,
                selectedTemplate: null
            });
        }).catch(err => {
            console.log(err);
        });
    }

    onOkModal = () => {
        this.setState({
            messageAlertModal: "",
            colorAlertModal: "",
            showAlertModal: false
        });
    }

    onToggleModal = () => {
        this.setState({
            messageAlertModal: "",
            colorAlertModal: "",
            showAlertModal: false
        });
    }

    render() {
        return (
            <Fragment>
                <div className="card__title">
                    <h5 className="bold-text">Laboratorio</h5>
                </div>
                <div>
                    <br />
                    <Row>
                        <Col md={6}>
                            <TextField
                                id="selectFormat"
                                label="Plantilla"
                                select
                                value={this.state.selectedTemplate}
                                className='medical-material-form__field'
                                onChange={(event) => {
                                    this.handlerSelectedTemplate(event.target.value);
                                }}
                                style={{ minWidth: '100%', maxWidth: '100%' }}
                            >
                                <MenuItem key={0} value={null}>
                                    Ninguna
                                </MenuItem>
                                {this.state.otherTemplates.map((otherTemplate) => {
                                    return <MenuItem key={otherTemplate.id_laboratorio_plantillas} value={otherTemplate.id_laboratorio_plantillas}>
                                        {otherTemplate.plantilla}
                                    </MenuItem>
                                })}
                            </TextField>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <TextField
                                id="selectFormat"
                                label="Nombre de la Plantilla"
                                value={this.state.templateData}
                                className='medical-material-form__field'
                                onChange={(event) => {
                                    this.handlerTemplateData(event.target.value);
                                }}
                                style={{ minWidth: '100%', maxWidth: '100%' }}
                                InputLabelProps={{
                                    shrink: this.state.templateData != null && this.state.templateData != "" ? true : false
                                }}
                            />
                        </Col>
                        <Col md={6}>
                            <TextField
                                required
                                className='medical-material-form__field'
                                id="formatName"
                                label="Habilitado"
                                select
                                value={this.state.enabledTemplate}
                                onChange={(event) => {
                                    this.handlerEnabledTemplate(event.target.value);
                                }}
                            >
                                <MenuItem key={0} value={true}>
                                    Si
                                </MenuItem>
                                <MenuItem key={1} value={false}>
                                    No
                                </MenuItem>
                            </TextField>
                        </Col>
                        <Col md={12}>
                            <div style={{ margin: 10 }}>
                                {<CKEditor
                                    style={{ width: '100%', height: '200px' }}
                                    editor={ClassicEditor}
                                    data={this.state.containData}
                                    onChange={(event, editor) => {
                                        const data = editor.getData();
                                        this.handlerContainData(data);
                                    }}
                                />}
                            </div>
                        </Col>
                    </Row>
                    <br />
                    <Button color="primary" onClick={() => this.validateSendTemplate()}>
                        Guardar
                    </Button>

                    {
                        this.state.selectedTemplate != null && this.state.selectedTemplate != undefined ? <Button color="danger" onClick={() => this.deleteDataTemplate()}>
                            Eliminar
                        </Button> : null
                    }

                </div>


                <AlertModal
                    color={this.state.colorAlertModal}
                    title={this.state.messageAlertModal}
                    modal={this.state.showAlertModal}
                    onOk={() => this.onOkModal()}
                    toggle={() => this.onToggleModal()}
                />

            </Fragment >
        );
    }
}

export default LabsPatientTemplates;